import React, { useState, createContext, useEffect } from 'react';

export const LayoutContext = createContext();

export const LayoutProvider = ({ children }) => {
    const mql = window.matchMedia('screen and (max-width: 800px)');
    const [mobileActive, setMobileActive] = useState(mql.matches);

    const changeLayout = ((e) => {
        setMobileActive(e.matches);
    });

    useEffect(() => {
        mql.addEventListener('change', changeLayout);

        return () => mql.removeEventListener('change', changeLayout);
    }, []);

    return (
        <LayoutContext.Provider value={{ mobileActive }}>
            {children}
        </LayoutContext.Provider>
    );
};
